import { useMutation } from '@tanstack/react-query';
import { updateCommissionsStatus, UpdateCommissionsStatusParams } from 'config/requests/comissions';

export function useUpdateCommissionsStatus() {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateCommissionsStatusParams }) =>
      updateCommissionsStatus(id, data),
  });
}
